export enum SortDirection {
    ASC = 0,
    DESC = 1
}